import ContentLoader from "react-content-loader"

export function RecentTransactionsSkeleton() {
  return (
    <div className="flex flex-col items-start justify-start">
      <p className="text-white text-lg font-bold my-2">Recent Transactions</p>

      <div className="w-full bg-card rounded-xl p-4 h-[300px] overflow-hidden">
        <ContentLoader
          speed={2}
          width="100%"
          height={280}
          viewBox="0 0 800 280"
          backgroundColor="#2d2d2d"
          foregroundColor="#444"
        >
          {/* Header row */}
          <rect x="0" y="10" rx="4" ry="4" width="100%" height="20" />

          {/* Table rows */}
          <rect x="0" y="50" rx="4" ry="4" width="100%" height="20" />
          <rect x="0" y="90" rx="4" ry="4" width="100%" height="20" />
          <rect x="0" y="130" rx="4" ry="4" width="100%" height="20" />
          <rect x="0" y="170" rx="4" ry="4" width="100%" height="20" />
          <rect x="0" y="210" rx="4" ry="4" width="100%" height="20" />
        </ContentLoader>
      </div>
    </div>
  )
}
